export class AppUrl {
  public static readonly BASE_URL = "https://agrichikitsa.org/api/v1";
  public static readonly userEndPoint = `${this.BASE_URL}/user`;
  public static readonly authEndpoint = `${this.BASE_URL}/auth`;
  protected static weatherApi =
    "https://api.weatherapi.com/v1/current.json?key=271bc5e4d5414345a0233026231509&q=25.39732 , 81.85809&aqi=no";
}
